<template>
    <a-modal v-model="visible"  :footer="null"  :width="320" class="export-excel" centered >
    <div class="export-excel-content">
        <div class="export-excel-content-title">收藏数据导出</div>
        <div>确认数据导出收藏数据？</div>
        <div style="">导出数据将以.XLS格式保存数据。</div>
        <div>
            <a :href="excelToExportUrl.replace('$type',type).replace('$token',$cookies.get('access-token'))" @click="visible=false">
              <a-button type="primary" size="large"  style="width: 100%;" @click="exportExcel">
              确认导出
              </a-button>  
            </a>
        </div>
    </div>
    </a-modal>
</template>

<script>
export default {
    data() {
        return {
        visible: true
        };
  },
  props: {
    type: {
      required: true,
      type: Number
    }
  },
  methods: {
    exportExcel() {
     
    }
  }
  }
</script>

<style lang="scss">
.export-excel{
    color: #afb1b1; 
    .ant-modal-body{
      padding: 0;
    }
    .ant-modal-close-x{
      height: 45px;
      width: 45px;
      line-height: 45px;
    }
    .export-excel-content{
      text-align: center;
      .export-excel-content-title{
        font-weight: bold;
        width: 100%;
        height: 45px;
        padding: 5px 20px;
        font-size: 16px;
        line-height: 35px;
        background-color: #f5fcff;
        border-top-left-radius: 5px;
        border-top-right-radius: 5px; 
        box-shadow: 0px 1px 5px #c7dfea ;
        text-align: left;
      }
      div:nth-of-type(2){
        font-size: 22px;
        font-weight: bold;
        color: black;
        padding-top: 40px;
      }
      div:nth-of-type(4){
        padding: 40px 20px 25px;
      }
    }
}
</style>